import { get, isUndefined, isEmpty, flatten, compact } from 'lodash-es'
import GETTER_TYPES from './getter-types'
import CONSTANTS from './constants.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import BIKE_ATTRIBUTES from '@/js/helper/bike-attributes.js'
import { types as STORE_MODULES } from '@/js/plugins/store/store-modules'
import APP_GETTER_TYPES from '@/js/plugins/store/modules/app/getter-types'

export default {
  [GETTER_TYPES.SEARCH_PRODUCT_TYPE]: (state, getters, rootState, rootGetters) => {
    return FILTER_CONSTANTS.FE_SCOPE_TO_PRODUCT_TYPE[
      rootGetters[`${STORE_MODULES.APP}/${APP_GETTER_TYPES.SCOPE}`]
    ]
  },
  [GETTER_TYPES.SEARCH_PARAMS]: state => {
    return Object.keys(CONSTANTS.TYPE).reduce((params, type) => {
      if (
        !isUndefined(state[CONSTANTS.TYPE[type]])
        // && CONSTANTS.TYPE[type] !== CONSTANTS.TYPE.SEARCH_SKU // Leave out SearchSku. It is a special search param
      ) {
        params[CONSTANTS.TYPE[type]] = state[CONSTANTS.TYPE[type]]
      }
      return params
    }, {})
  },
  [GETTER_TYPES.SEARCH_SKU]: state => {
    return get(state, CONSTANTS.SEARCH_SKU)
  },
  [GETTER_TYPES.SEARCH_PARAMS_CURRENT]: (state, getters) => {
    return Object.entries(getters[GETTER_TYPES.SEARCH_PARAMS]).reduce((acc, [key, value]) => {
      switch (key) {
        // case BIKE_ATTRIBUTES.TYPE.ITEM_BRAND:
        // case BIKE_ATTRIBUTES.TYPE.PRODUCT_SEGMENT:
        // case BIKE_ATTRIBUTES.TYPE.PRODUCT_MAIN_CATEGORY:
        // case BIKE_ATTRIBUTES.TYPE.PRODUCT_BIDEX_COMMODITY_GROUP:
        // case BIKE_ATTRIBUTES.TYPE.EBIKE_ENGINE_MODEL:
        // case BIKE_ATTRIBUTES.TYPE.EBIKE_SYSTEM_BRAND:
        // case BIKE_ATTRIBUTES.TYPE.ITEM_BATTERY_WATT_HOURS:
        case BIKE_ATTRIBUTES.TYPE.ITEM_COLOR:
        case BIKE_ATTRIBUTES.TYPE.ITEM_FILTER_COLOR:
        case BIKE_ATTRIBUTES.TYPE.ITEM_GENDER_FRAME:
        case BIKE_ATTRIBUTES.TYPE.ITEM_WHEEL_SIZE_INCH:
        case BIKE_ATTRIBUTES.TYPE.PRODUCT_GEAR_TYPE:
        case BIKE_ATTRIBUTES.TYPE.ITEM_COASTER_BRAKE:
        case BIKE_ATTRIBUTES.TYPE.ZZCA_CLIENT:
        case FILTER_CONSTANTS.TYPE.STOCK: {
          if (!isUndefined(value) && !isEmpty(value)) acc[key] = value
          break
        }
        // case FILTER_CONSTANTS.TYPE.PRODUCT_VARIANTS:
        case FILTER_CONSTANTS.TYPE.ITEM_FRAME_SIZE: {
          const flattenedValue = compact(flatten(Object.values(value)))
          if (!isEmpty(flattenedValue)) {
            acc[key] = flattenedValue
          }
          break
        }
      }
      return acc
    }, {})
  },
}
